module.exports = __webpack_public_path__ + "24879fbcdbcf458813d69c463fb74622.jpg";